import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import Nav from './Nav';
import 'normalize.css'; // imported as dependency, see package.json
import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import { LocaleProvider } from './LocaleContext';
import { ModalProvider } from './ModalContext';
// import Modal from './Modal';

const ContentStyles = styled.div`
  margin-top: var(--navHeight);
`;

export default function Layout(props) {
  const { children, pageContext, data } = props;
  const { pageType } = pageContext;
  const journalPageClass =
    pageType === 'general' && data.page.categories.length ? 'journalPage' : '';

  // Inject scripts
  useEffect(() => {
    document.getElementById(
      'pipedrive-script'
    ).innerHTML = `<script>(function(ss,ex){ window.ldfdr=window.ldfdr||function(){(ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));};
        (function(d,s){ fs=d.getElementsByTagName(s)[0]; function ce(src){ var cs=d.createElement(s); cs.src=src; cs.async=1;
        fs.parentNode.insertBefore(cs,fs); }; ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js'); })(document,'script'); })
        ('JMvZ8gbvPO1a2pOd');</script>`;
  }, []);

  return (
    <>
      {/* Google tag manager no script */}
      <noscript>
        <iframe
          title="Google Tag Manager"
          src="https://www.googletagmanager.com/ns.html?id=GTM-WM38SWB"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      {/* Pipedrive */}
      <div id="pipedrive-script" style={{ visibility: 'hidden' }} />
      <LocaleProvider pageContext={pageContext}>
        <ModalProvider>
          <GlobalStyles />
          <Typography />
          <Nav
            className={`${pageType}Page ${pageContext.slug} ${journalPageClass}`}
          />
          <ContentStyles className={`${pageType}Page ${pageContext.slug}`}>
            {children}
          </ContentStyles>
        </ModalProvider>
      </LocaleProvider>
    </>
  );
}

export const query = graphql`
  fragment LocaleStringFields on SanityLocaleString {
    _type
    en
    es
  }

  fragment LocaleBlockFields on SanityLocaleBlock {
    _type
    en {
      _key
      _type
      children {
        marks
        text
        _type
      }
    }
    es {
      _key
      _type
      children {
        marks
        text
        _type
      }
    }
  }

  fragment SiteSettingsFields on SanitySiteSettings {
    instagram
    facebook
    twitter
    _rawVaultLegend
    _rawNewsletterLegend
    contactCategories {
      ...LocaleStringFields
    }
  }

  fragment JournalCategoryFields on SanityJournalCategory {
    name {
      ...LocaleStringFields
    }
    slug {
      ...LocaleStringFields
    }
  }
`;
